<template>
  <v-sheet elevation="2" class="px-12 py-8 rounded white">
    <div class="mb-6">
      <p class="h6 pa-0 mb-0">
        {{ $t('organization_settings.api_keys') }}
      </p>
      <p class="mt-2 pa-0 grey--text text--darken-2">
        {{ $t('organization_settings.api_keys_description') }}

        <a
          href="https://developers.reverscore.com"
          class="text-decoration-none"
          target="_blank"
        >
          {{ $t('organization_settings.refer_to_our_documentation') }}
        </a>
      </p>
    </div>

    <APIKeysList :organizationId="organizationId" />
  </v-sheet>
</template>

<script>
import APIKeysList from './APIKeysList.vue'

export default {
  name: 'APIKeysView',

  components: {
    APIKeysList,
  },

  props: {
    organizationId: {
      required: true,
      type: String,
    },
  },
}
</script>
